import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, networkLogos, sportIds, teamIds, videos } from 'src/constants'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { PlanTypes } from 'src/constants/standaloneData'
import { useIsRSNAvailable } from 'src/modules/hooks/useIsRSNAvailable'
export default (props) => {
  const { isAvailable } = useIsRSNAvailable(PlanTypes.RANGERS_SPORTS_NETWORK)
  const rangersPlan = usPlanData.rangers_sports_network_monthly
  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    video: videos.texas_rangers.videoUrl,
    staticAnnotation: networkLogos.rangers_sports_network,
    title: 'Watch Rangers Sports Network with Fubo',
    subtitle: 'STREAM LIVE GAMES WITHOUT CABLE. CLOUD DVR INCLUDED.',
    networkSet: 'baseball',
    customNetworks: ['rangers_sports_network'],
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-texas-rangers.png?w=450&ch=width&auto=format,compress',
    logoHeight: '100px',
    league: 'MLB',
    sportId: sportIds.Baseball,
    leagueId: leagueIds.MLB,
    teamId: teamIds['Texas Rangers'],
    planName: PlanTypes.RANGERS_SPORTS_NETWORK,
  }
  
  return isAvailable ? (
    <FuboFreeTemplate
      {...commonProps}
      hasPlanCards={true}
      plans={[rangersPlan, usPlanData.pro_standalone_monthly]}
      plansSharedData={{
        rsn: rangersPlan.rsn,
        teams: rangersPlan.teams,
      }}
      additionalFAQs={additionalFAQs}
    />
  ) : (
    <USTemplateDefault {...commonProps} />
  )
}

const additionalFAQs = [
  {
    question: 'Can I watch Texas Rangers games on Fubo?',
    answer:
      'Yes, you can watch Texas Rangers games on Rangers Sports Network with Fubo. This allows you to catch all the live action during Rangers season.',
  },
  {
    question: 'How can I find Texas Rangers games on Fubo?',
    answer:
      "To find Texas Rangers games on Fubo, simply use the search feature in the app or website. You can search for 'Texas Rangers' or browse the Sports section to see the upcoming game schedule.",
  },
  {
    question: 'Is live coverage of MLB games available on Fubo?',
    answer:
      'Yes, Fubo offers live coverage of MLB games including the Texas Rangers on Rangers Sports Network. Just subscribe to Rangers Sports Network with Fubo to watch live Texas Rangers games.',
  },
  {
    question: 'Can I watch commentary and analysis of Texas Rangers games on Fubo?',
    answer:
      'Yes, Fubo has many shows that offer commentary and analysis of Texas Rangers games. Look for sports talk shows and pre-game coverage on Rangers Sports Network.',
  },
  {
    question: 'How do I watch MLB highlights on Fubo?',
    answer:
      "You can watch MLB highlights on Fubo by checking the Sports section or by searching for 'MLB.' Highlights are often available shortly after games end.",
  },
  {
    question: 'Are there any special events or features related to the Texas Rangers on Fubo?',
    answer:
      'Yes, Fubo often features special events related to the Texas Rangers, including player interviews and behind-the-scenes content. Keep an eye on the sports schedule for these exclusive features.',
  },
  {
    question: 'How do I watch Rangers games on Rangers Sports Network with Fubo?',
    answer:
      'You can subscribe to Rangers Sports Network with Fubo wherever Rangers Sports Network is available. When you subscribe with Fubo you get 150+ free live TV channels, Unlimited Cloud DVR to record Rangers games and more, and the ability to watch on up to 10 devices at the same time.',
  },
  {
    question: 'How can I stay updated on the Texas Rangers game schedules on Fubo?',
    answer:
      'To stay updated on the Texas Rangers game schedules, check the Sports section on Fubo regularly. You can also set reminders for specific games to ensure you don’t miss any action.',
  },
]
